function sortByPostalCodeAndSuburb(array) {
    return array.sort((a, b) => {
        if (a._source.postal_code < b._source.postal_code) return -1;
        if (a._source.postal_code > b._source.postal_code) return 1;

        return a._source.suburb.localeCompare(b._source.suburb);
    });
}

module.exports = {
    sortByPostalCodeAndSuburb,
};



// WEBPACK FOOTER //
// ./src/commons/addresses.js